<template>
  <section class="heroSection">
    <h1 class="heroTitle">Africa's #1 Podcast Hosting and Monetizing platform</h1>
    <p class="heroText">Afripods is the easiest way to produce, edit and grow your podcast audience in Africa.</p>

    <button
      class="btn-round-yellow heroButton"
      @click="
        onRedirect({ name: 'PodcasterPodcastListAdd', params: { section: 'list', action: 'add', recordId: '0' } })
      "
    >
      Create your podcast for free
    </button>

    <p class="heroText">
      Already have a podcast?
      <button class="btn-unstyled" @click="onRedirect({ name: 'PodcasterMigratePodcast' })">Migrate it here</button>
    </p>
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router/composables'

const router = useRouter()

// eslint-disable-next-line unicorn/prevent-abbreviations
const onRedirect = ({ name, params = {} }) => {
  const userIsLoggedIn = localStorage.getItem('afripodsLoggedInAccountType') !== null
  router.push({ name: userIsLoggedIn ? name : 'PodcasterRegister', params })
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/bootstrap_variables';
@import 'assets/scss/base/functions';

.heroSection {
  text-shadow: 0 4px 4px rgb(0 0 0 / 25%);

  .heroTitle {
    font-size: clamp(to-rem(36), 4.7vw + to-rem(1), to-rem(72));
    font-weight: 400;
    line-height: 1.1;
    color: inherit;

    @media (min-width: $screen-sm-min) {
      max-width: 70%;
    }

    @media (min-width: $screen-xl-min) {
      max-width: 900px;
    }
  }

  .heroText {
    margin-top: 32px;
    font-size: to-rem(16);
    line-height: 1.5;

    @media (min-width: $screen-md-min) {
      font-size: to-rem(20);
    }

    button {
      font-weight: 600;
      color: $color-white;
      text-decoration: underline;
    }
  }

  .heroButton {
    margin-top: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// HeroSection.vue